import EmailLabel from '@monorepo/common/component/EmailLabel';
import { IconRegularEdit, IconSolidUserPlus } from '@monorepo/common/component/Icons';
import PersonNameLabel from '@monorepo/common/component/person/PersonNameLabel';
import PhoneLabel from '@monorepo/common/component/PhoneLabel';
import RegistrationInfoLabel from '@monorepo/common/component/RegistrationInfoLabel';
import Secured, { ROLE_ADMIN_PERSON_DELETE } from '@monorepo/common/component/Secured';
import SexLabel from '@monorepo/common/component/SexLabel';
import React, { ReactNode } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { ModuleCol } from '../client/ClientDetailView';
import LegalRepresentationList, { LegalRepresentationType } from '../legalRepresentation/LegalRepresentationList';
import PersonDetailDeleteModal from './PersonDetailDeleteModal';
import PersonDetailEditModal from './PersonDetailEditModal';

interface PersonRowProps {
  label: string;
  value?: ReactNode;
  children?: ReactNode;
}

const PersonRow = ({ label, value, children }: PersonRowProps) => {
  return (
    <Row>
      <Col sm={12} md={5}>
        <span className="text-muted">{label}</span>
      </Col>
      <Col sm={12} md={7}>
        {children || value}
      </Col>
    </Row>
  );
};

export const NewPersonIcon = () => (
  <PersonDetailEditModal title="Nová osoba">
    {(handleModalOpen, title) => (
      <h2>
        <IconSolidUserPlus onClick={handleModalOpen} title={title} className="action-icon text-primary" />
      </h2>
    )}
  </PersonDetailEditModal>
);

export interface PersonType {
  __typename?: 'Person';
  id: string;
  personData: {
    __typename?: 'PersonData';
    id: string;
    degreeBefore?: string | null;
    degreeAfter?: string | null;
    firstName: string;
    lastName: string;
    sex?: string | null;
    phone?: number | null;
    phone2?: number | null;
    email?: string | null;
    note?: string | null;
    personalDataVerified: boolean;
    legalRepresentationsChilds: LegalRepresentationType[];
  };
}

interface PersonDetailViewProps {
  person: PersonType;
}

export default function PersonDetailView({ person }: PersonDetailViewProps) {
  const { personData } = person;
  return (
    <>
      {/*Header with name and New icon*/}
      <Row>
        <Col>
          <PersonDetailEditModal key={person.id} title="Změna osoby" person={person}>
            {(handleModalOpen, title) => (
              <h2>
                <IconRegularEdit onClick={handleModalOpen} title={title} className="action-icon text-primary" />
                <PersonNameLabel person={person} />
              </h2>
            )}
          </PersonDetailEditModal>
        </Col>
      </Row>

      {/*Person info*/}
      <Row>
        <Col sm={6}>
          <PersonRow label="Telefon">
            <PhoneLabel phoneNumber={personData.phone} />
          </PersonRow>

          <PersonRow label="Telefon2">
            <PhoneLabel phoneNumber={personData.phone2} />
          </PersonRow>
        </Col>
        <Col sm={6}>
          <PersonRow label="E-mail">
            <EmailLabel email={personData.email} />
          </PersonRow>
          {/*@ts-ignore*/}
          <PersonRow label="Pohlaví">{personData.sex && <SexLabel sex={personData.sex} />}</PersonRow>

          <PersonRow label="Registrace">
            <RegistrationInfoLabel personalDataVerified={personData.personalDataVerified} />
          </PersonRow>

          <PersonRow label="Poznámka" value={personData.note} />
        </Col>
      </Row>

      {/*Person modules*/}
      <Row>
        <ModuleCol lg={8}>
          <LegalRepresentationList
            representative={person}
            legalRepresentationsChilds={personData.legalRepresentationsChilds}
            legalRepresentationsRepresentatives={[]}
          />
        </ModuleCol>
      </Row>

      <Row>
        <ModuleCol>
          <Secured authority={ROLE_ADMIN_PERSON_DELETE}>
            <PersonDetailDeleteModal key={person.id} person={person}>
              {(handleModalOpen, title) => (
                <Button color="danger" onClick={handleModalOpen} title={title}>
                  Smazání osoby
                </Button>
              )}
            </PersonDetailDeleteModal>
          </Secured>
        </ModuleCol>
      </Row>
    </>
  );
}
